import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemPhotosDelete: "",
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemPhotosDeleteSlice = createSlice({
  name: "itemPhotosDeleteSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showDeleteItemPhotosDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemPhotosDelete: action.payload,
      };
    },
    closeDeleteItemPhotosDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showDeleteItemPhotosDialog,
  closeDeleteItemPhotosDialog,
  showLoading,
  hideLoading
} = itemPhotosDeleteSlice.actions;

export default itemPhotosDeleteSlice.reducer;
